import React from "react";
import {
  Radio as AntdRadio,
  RadioGroupProps as AntdRadioGroupProps,
  RadioProps as AntdRadioProps,
} from "antd";

export type ButtonGroupProps = {
  children: React.ReactNode;
} & AntdRadioGroupProps;

const ButtonGroup = ({ children, ...props }: ButtonGroupProps) => {
  return <AntdRadio.Group {...props}>{children}</AntdRadio.Group>;
};

type ButtonGroupButtonProps = AntdRadioProps & {
  icon?: React.ReactNode;
};

const ButtonGroupButton = ({ icon, ...props }: ButtonGroupButtonProps) => {
  return (
    <AntdRadio.Button {...props}>
      {icon ? icon : props.children}
    </AntdRadio.Button>
  );
};

ButtonGroup.Button = ButtonGroupButton;

export default ButtonGroup;
